import { useState, useEffect } from 'react';
import { useLabels } from 'wsm-common-data';
import {
	usePublishFilterVisibility,
	useSubscribeFilterVisibility
} from '../hooks/useFilterVisibility';

const FILTER_LABEL_KEY = 'A_FILTER';

const FilterToggleButton = () => {
	const labels = useLabels();
	const { publishVisibility } = usePublishFilterVisibility();
	const { subscribeToVisibility } = useSubscribeFilterVisibility();
	const [isFilterVisible, setIsFilterVisible] = useState(false);

	// Reset filter visibility when component unmounts (e.g. navigating to default view)
	useEffect(() => {
		return () => publishVisibility(false);
	}, [publishVisibility]);

	// Subscribe to visibility changes from other widgets
	useEffect(() => {
		const unsubscribe = subscribeToVisibility((visible) => {
			// React to visibility change
			setIsFilterVisible(visible);
		});

		// Cleanup: unsubscribe when component unmounts
		return unsubscribe;
	}, [subscribeToVisibility]);

	const handleToggle = (e) => {
		e.preventDefault();
		const newFilterVisible = !isFilterVisible;
		publishVisibility(newFilterVisible);
	};

	const filterLabel = labels.get(FILTER_LABEL_KEY) || 'Filter';
	const hideFilterLabel =
		labels.get('HIDE_LOCATION_FILTERS') || 'Hide location filters';
	const showFilterLabel =
		labels.get('SHOW_LOCATION_FILTERS') || 'Show location filters';

	return (
		<button
			className="btn btn-default mt-3"
			onClick={handleToggle}
			type="button"
			aria-pressed={isFilterVisible}
			aria-label={isFilterVisible ? hideFilterLabel : showFilterLabel}
		>
			<i
				className="ddc-icon ddc-icon-filter-list-controls mr-2"
				aria-hidden="true"
			/>
			{filterLabel}
		</button>
	);
};

export default FilterToggleButton;
